let purchase = {
  title: "Residential agent",
  data_recharge: "Data recharge",
  other_packages: "Other packages",
  item: {
    item_1: "Unlimited concurrent sessions",
    item_2: "The balance is permanently valid",
    item_3: "99.89% uptime",
    item_4: "Supports country and city level targeting"
  },
  ready: "Ready to get started?",
  contact_sales: "Contact Sales"
}
export default purchase


// WEBPACK FOOTER //
// ./src/assets/lang/en/new_purchase/index.js